import type { Supplier } from '../types/inventory';

// Ola 3: opciones del selector de proveedor dentro de Crear/Editar presentación.
// Reglas: solo proveedores utilizables del negocio actual — ACTIVOS y aprobados (un proveedor sin
// approvalStatus es de antes de 26A y cuenta como aprobado). Un REJECTED jamás aparece como opción
// normal. Si la presentación ya traía guardado un nombre que hoy no está en el catálogo utilizable
// (texto libre histórico, proveedor desactivado o propuesta aún pendiente), se conserva como opción
// marcada para no perder el dato al editar.
export function selectableSupplierOptions(suppliers: Supplier[], currentName: string): Array<[value: string, label: string]> {
  const usable = suppliers
    .filter((supplier) => supplier.isActive && (!supplier.approvalStatus || supplier.approvalStatus === 'ACTIVE'))
    .map((supplier) => [supplier.name, supplier.name] as [string, string])
    .sort((left, right) => left[0].localeCompare(right[0], 'es'));
  const trimmed = currentName.trim();
  if (trimmed && !usable.some(([name]) => name === trimmed)) {
    const pending = suppliers.some((supplier) => supplier.name === trimmed && supplier.approvalStatus === 'PENDING_APPROVAL');
    usable.unshift([trimmed, pending ? `${trimmed} (pendiente de aprobación)` : `${trimmed} (fuera del catálogo)`]);
  }
  return usable;
}
